import { FileUploadValidationsConfiguration } from '@/api/interfaces/configuration/form/base/fielUploadValidationsConfiguration';
import Vue from 'vue';

export const appConfiguration = Vue.observable({
    fileUploadConfigurations: {} as {
        [key: string]: FileUploadValidationsConfiguration;
    },
});
